import React from 'react';
import { getKey } from '@src/services/api';

const useSina = () => {
    const sinaInit = async () => {
        const req = (await getKey()) || {};

        if (req?.code === 0) {
            const { data = {} } = req;
            const { appKey, noncestr, signature, timestamp } = data;

            try {
                // eslint-disable-next-line no-undef
                wb.init({
                    debug: false,
                    appkey: appKey,
                    timestamp,
                    noncestr,
                    signature,
                    scope: ['openMenu', 'setSharingContent'],
                });
            } catch (error) {
                console.log(error);
            }
        }
    };

    const openMenu = ({ pageData, successFn, failureFn }) => {
        // eslint-disable-next-line no-undef
        wb.ready(() => {
            // eslint-disable-next-line no-undef
            wb.setSharingContent({
                icon: pageData.shareImgUrl,
                title: pageData.shareDesc,
                desc: pageData.shareTitle,
                success() {
                    // eslint-disable-next-line no-undef
                    wb.openMenu({
                        success(res) {
                            console.log(res);
                            successFn();
                        },
                        fail(res) {
                            if (failureFn) {
                                failureFn();
                            }
                        },
                    });
                },
                fail() {
                    if (failureFn) {
                        failureFn();
                    }
                },
            });
        });
    };

    return { sinaInit, openMenu };
};

export default useSina;
